import {Uszkodzenie} from '../../../../../../../../shared/store/zbior-uszkodzen/zbiorUszkodzen';
import {SlownikUszkodzen} from '../../../../../../../../shared/model/uszkodzenia/slownik-uszkodzen';

export class StrategiaPodsumowaniaUszkodzenia {
  constructor(public slownikUszkodzen: SlownikUszkodzen, public uszkodzenie: Uszkodzenie<any>) {}
}
